import axios from "axios/index";
import api from "../../config/_api";

const state = {
    rentals: [],
    system_id: null,
};
const actions = {

    load({commit, state, rootGetters}, payload) {

        // Clean rentals for display purpose
        commit("setRentals", []);

        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => { axios.get(api.url + 'rentals', {
                params : {
                    'structure_id' : rootGetters.structure_id,
                    'system_id' : state.system_id,
                    'startDate' : payload.startDate,
                    'endDate' : payload.endDate
                }
            }).then((response) => {
                commit("setRentals", response.data);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        })  
    },
    create({commit, state, rootGetters}, payload) {

        const params = new URLSearchParams();
        params.append('start', payload.start);
        params.append('end', payload.end);
        params.append('activity', payload.activity == null ? '': payload.activity);
        params.append('adherent_id', payload.adherent_id);
        params.append('system_id', state.system_id);
        params.append('structure_id', rootGetters.structure_id);

        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'rentals', params)
            .then((response) => {
                commit('removeRental', -1);
                commit('addRental', response.data);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    delete({commit, rootGetters}, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(api.url + 'rentals/' + payload.id, {
                params : {'structure_id' : rootGetters.structure_id}
            })
            .then((response) => {
                commit('removeRental', payload.id);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    update({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        params.append('start', payload.start);
        params.append('end', payload.end);
        params.append('activity', payload.activity == null ? '': payload.activity);
        params.append('adherent_id', payload.adherent_id);
        params.append('system_id', state.system_id);
        params.append('structure_id', rootGetters.structure_id);
    
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'rentals/' + payload.id, params)
            .then((response) => {
                commit('removeRental', payload.id);
                commit('addRental', response.data);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
        
        
    },
    updateReal({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        params.append('start', payload.start);
        params.append('end', payload.end);
        params.append('start_val', payload.start_val);
        params.append('end_val', payload.end_val);
        params.append('activity', payload.activity == null ? '': payload.activity);
        params.append('adherent_id', payload.adherent_id);
        params.append('system_id', state.system_id);
        params.append('structure_id', rootGetters.structure_id);
    
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'rentals/' + payload.id, params)
            .then((response) => {
                commit('removeRental', payload.id);
                commit('addRental', response.data);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
        
    },
    refresh({commit, rootGetters}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(api.url + 'rentals/' + payload.id, {
                params : {'structure_id' : rootGetters.structure_id}
            })
            .then((response) => {
                commit('removeRental', payload.id);
                commit('addRental', response.data);
                resolve(response.data);
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    confirm({commit, rootGetters}, payload) {

        const params = new URLSearchParams();
        params.append('cumul_valid', payload.cumul_valid);
        params.append('structure_id', rootGetters.structure_id);
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'rentals/' + payload.id + '/confirm', params)
            .then((response) => {
                commit('removeRental', payload.id);
                commit('addRental', response.data);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    disconfirm({commit, rootGetters}, payload) {

        return new Promise((resolve, reject) => {
            axios.get(api.url + 'rentals/' + payload.id + '/disconfirm', {
                params : {'structure_id' : rootGetters.structure_id}
            }).then((response) => {
                commit('removeRental', payload.id);
                commit('addRental', response.data);
                resolve(response.data);
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    validate({commit, rootGetters}, payload){
        
        return new Promise((resolve, reject) => {
            axios.get(api.url + 'rentals/' + payload.id + '/valider', {
                params : {'structure_id' : rootGetters.structure_id}
            }).then((response) => {
                commit('removeRental', payload.id);
                commit('addRental', response.data);
                resolve(response.data);
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    addFake({commit}, payload) {
        var rental = {
            'id' : -1,
            'start' : payload.startDate,
            'end' : payload.endDate,
            'class' : 'default'
        };
        commit('addRental', rental);
    },
    removeFake({commit}) {
        commit('removeRental', -1);
    },
    setSystemId({commit}, payload) {
        commit('setSystemId', parseInt(payload.system_id));
    },
    deleteCurrent({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        params.append('structure_id', rootGetters.structure_id);
        //params.append('startDate', payload.startDate);
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'rentals/delete_current/' + payload.sysid, params)
            .then((response) => {
                commit('removeRental', 0);
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    stopCurrent({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        params.append('structure_id', rootGetters.structure_id);
        //params.append('startDate', payload.startDate);
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'rentals/stop_current/' + payload.sysid, params)
            .then((response) => {
                resolve({ status : response.status })
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    }
};
const mutations = {
    ['setRentals']: (state, rentals) => {
        state.rentals = rentals;
    },
    ['addRental']: (state, rental) => {
        state.rentals.push(rental);
    },
    ['removeRental']: (state, id) => {
        var index = state.rentals.findIndex(event => event.id === id);
        state.rentals.splice(index, 1);
    },
    ['setSystemId']: (state, system_id) => {
        state.system_id = system_id
    }
};
const getters = {
    getRentals : state => state.rentals,
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
//# sourceMappingURL=sensors.js.map